var render = function () {
  var _vm$walletData, _vm$walletData$user, _vm$walletData2, _vm$walletData2$user, _vm$walletData3, _vm$walletData3$user, _vm$walletData4, _vm$walletData4$user, _vm$walletData5, _vm$walletData5$user, _vm$walletData6, _vm$walletData6$user, _vm$walletData7, _vm$walletData7$user, _vm$walletData8, _vm$walletData8$walle, _vm$walletData9, _vm$walletData9$walle, _vm$walletData0, _vm$walletData0$walle, _vm$walletData1, _vm$walletData1$walle;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wallet-header"
  }, [_c('b-container', {
    attrs: {
      "fluid": "xl"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row align-items-md-start"
  }, [_c('div', {
    staticClass: "avatar flex-shrink-0"
  }, [_c('img', {
    attrs: {
      "src": (_vm$walletData = _vm.walletData) === null || _vm$walletData === void 0 ? void 0 : (_vm$walletData$user = _vm$walletData.user) === null || _vm$walletData$user === void 0 ? void 0 : _vm$walletData$user.jersey,
      "alt": "Profile Picture"
    }
  })]), _c('div', {
    staticClass: "d-fle flex-column flex-grow-1"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3"
  }, [_c('h2', {
    staticClass: "username"
  }, [_c('span', {
    staticClass: "country-flag"
  }, [(_vm$walletData2 = _vm.walletData) !== null && _vm$walletData2 !== void 0 && (_vm$walletData2$user = _vm$walletData2.user) !== null && _vm$walletData2$user !== void 0 && _vm$walletData2$user.countryFlag ? _c('img', {
    attrs: {
      "src": (_vm$walletData3 = _vm.walletData) === null || _vm$walletData3 === void 0 ? void 0 : (_vm$walletData3$user = _vm$walletData3.user) === null || _vm$walletData3$user === void 0 ? void 0 : _vm$walletData3$user.countryFlag,
      "alt": "flag"
    }
  }) : _vm._e()]), _vm._v(" " + _vm._s(((_vm$walletData4 = _vm.walletData) === null || _vm$walletData4 === void 0 ? void 0 : (_vm$walletData4$user = _vm$walletData4.user) === null || _vm$walletData4$user === void 0 ? void 0 : _vm$walletData4$user.name) || "User") + " ")]), _vm.walletData && !_vm.isLoading ? [((_vm$walletData5 = _vm.walletData) === null || _vm$walletData5 === void 0 ? void 0 : (_vm$walletData5$user = _vm$walletData5.user) === null || _vm$walletData5$user === void 0 ? void 0 : _vm$walletData5$user.verificationStatus) === 'pending' ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "bi bi-info-circle-fill"
  }), _c('span', [_vm._v("Verification in progress")])]) : ((_vm$walletData6 = _vm.walletData) === null || _vm$walletData6 === void 0 ? void 0 : (_vm$walletData6$user = _vm$walletData6.user) === null || _vm$walletData6$user === void 0 ? void 0 : _vm$walletData6$user.verificationStatus) === 'rejected' ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/wallet/xsign.png",
      "alt": "icon"
    }
  }), _c('span', [_vm._v("Rejected")])]) : (_vm$walletData7 = _vm.walletData) !== null && _vm$walletData7 !== void 0 && (_vm$walletData7$user = _vm$walletData7.user) !== null && _vm$walletData7$user !== void 0 && _vm$walletData7$user.verified ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "success"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/wallet/verified.png",
      "alt": "icon"
    }
  }), _c('span', [_vm._v("verified")])]) : _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/wallet/xsign.png",
      "alt": "icon"
    }
  }), _c('span', [_vm._v("unverified")])])] : _vm._e()], 2), _c('div', {
    staticClass: "d-flex flex-column flex-md-row align-items-md-center bg-white p-4 mb-4"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('strong', {
    staticClass: "total-label"
  }, [_vm._v("Total Balance")]), _c('span', {
    staticClass: "balance"
  }, [_vm._v(" " + _vm._s(((_vm$walletData8 = _vm.walletData) === null || _vm$walletData8 === void 0 ? void 0 : (_vm$walletData8$walle = _vm$walletData8.walletData) === null || _vm$walletData8$walle === void 0 ? void 0 : _vm$walletData8$walle.balance) || "0.000000") + " " + _vm._s(((_vm$walletData9 = _vm.walletData) === null || _vm$walletData9 === void 0 ? void 0 : (_vm$walletData9$walle = _vm$walletData9.walletData) === null || _vm$walletData9$walle === void 0 ? void 0 : _vm$walletData9$walle.currency) || "BTC") + " ")]), _c('span', {
    staticClass: "consumed d-none"
  }, [_vm._v(" = $" + _vm._s(_vm.formatUSD((_vm$walletData0 = _vm.walletData) === null || _vm$walletData0 === void 0 ? void 0 : (_vm$walletData0$walle = _vm$walletData0.walletData) === null || _vm$walletData0$walle === void 0 ? void 0 : _vm$walletData0$walle.balanceUSD)) + " USD ")])]), _c('div', {
    staticClass: "user-action"
  }, [_vm._t("action-button", function () {
    return [_c('b-button', {
      staticClass: "fw-bold wallet-btn",
      attrs: {
        "variant": "warning"
      },
      on: {
        "click": _vm.handleWithdrawClick
      }
    }, [_vm._v(" Withdraw ")])];
  })], 2)]), _c('div', {
    staticClass: "data-time d-flex"
  }, [_c('span', [_vm._v("Last updated:")]), _c('span', [_vm._v(_vm._s((_vm$walletData1 = _vm.walletData) === null || _vm$walletData1 === void 0 ? void 0 : (_vm$walletData1$walle = _vm$walletData1.walletData) === null || _vm$walletData1$walle === void 0 ? void 0 : _vm$walletData1$walle.lastUpdated))])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }